import { IconClose } from '@/styles/Icon'
import { Dialog, Transition } from '@headlessui/react'
import { Fragment } from 'react'
export interface DrawRightProps {
  open: boolean
  children: JSX.Element[] | JSX.Element
  title: string
  onClose: () => void
  type?: string
  borderHead?: boolean
}

export function DrawRight({
  open,
  children,
  title,
  onClose,
  type = '',
  borderHead = false,
}: DrawRightProps) {
  return (
    <Transition show={open} as={Fragment}>
      <Dialog as='div' className='relative z-[99999999999]' onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter='ease-in-out duration-500'
          enterFrom='opacity-0'
          enterTo='opacity-100'
          leave='ease-in-out duration-500'
          leaveFrom='opacity-100'
          leaveTo='opacity-0'
        >
          <div
            className='fixed inset-0 left-0 bg-dark-900 bg-opacity-50 transition-opacity'
            aria-hidden='true'
          />
        </Transition.Child>
        <div className='fixed inset-0 overflow-hidden z-[99999999999]'>
          <div className='absolute inset-0 overflow-hidden'>
            <div className='pointer-events-none fixed inset-y-0 left-[50%] translate-x-[-50%] flex max-w-[440px]'>
              <Transition.Child
                as={Fragment}
                enter='transform transition ease-in-out duration-500 sm:duration-700'
                enterFrom='translate-x-full'
                enterTo='translate-x-0'
                leave='transform transition ease-in-out duration-500 sm:duration-700'
                leaveFrom='translate-x-0'
                leaveTo='translate-x-full'
              >
                <Dialog.Panel className='pointer-events-auto w-screen max-w-md'>
                  <div className='flex h-full flex-col bg-white relative ml-[15%]'>
                    <div
                      className={`headerModal relative w-full px-3 pt-4 pb-3 ${
                        borderHead ? 'border-b-4' : ''
                      } ${
                        type === 'filter'
                          ? 'h-[60px] mt-2.5 mb-3'
                          : 'h-[72px] mt-5'
                      }`}
                    >
                      <Dialog.Title as='h2' className={`text-lg font-bold`}>
                        {title}
                      </Dialog.Title>
                      <button
                        onClick={onClose}
                        className='absolute right-3 top-4 cursor-pointer z-10'
                      >
                        <IconClose />
                      </button>
                    </div>
                    {children}
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}

export default DrawRight
